import { render } from "./ColorListHolder.vue?vue&type=template&id=0d937eb2&scoped=true"
import script from "./ColorListHolder.vue?vue&type=script&lang=js"
export * from "./ColorListHolder.vue?vue&type=script&lang=js"

import "./ColorListHolder.vue?vue&type=style&index=0&id=0d937eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d937eb2"]])

export default __exports__